/**
 * Returns an Array of objects that are distinct to the defined key. higher indeces override lower indeces in the array.
 * @param objects the objects that should become distinct
 * @param getKey function to determin wich attribute should be the identifier for distinct objects
 * @param filter optional. only consider those objects where the filter returns true
 * @returns returns an array with distinct objects determined by the getKey function
 */
export function arrayToDistinct<T>(
  objects: T[],
  getKey: (obj: T) => string,
  filter?: (obj: T) => boolean
) {
  const map = new Map<string, T>();
  objects.forEach((object) => {
    const currentKey = getKey(object);
    if (!filter || filter(object)) map.set(currentKey, object);
  });

  return Array.from(map, (pair) => pair[1]);
}

/*

EXAMPLE

const arr = [
  {
    person: { name: "max", id: "0" },
    job: { title: "Developer" },
  },
  {
    person: { name: "tim", id: "1" },
    job: { title: "Developer" },
  },
  {
    person: { name: "max", id: "0" },
    job: { title: "Project Manager" },
  },
];

console.log(distinct(arr, (obj) => obj.person.id));

Output: 
[
  {
    person: { name: "tim", id: "1" },
    job: { title: "Developer" },
  },
  {
    person: { name: "max", id: "0" },
    job: { title: "Project Manager" },
  },
]
*/
